/**
 * Financial-advisory specific GroupNode that injects Redux state
 * for evaluation examples used in the "Low Confidence" indicator.
 *
 * This component wraps the shared GroupNode and provides evaluation
 * examples from Redux via the selectEvaluationExamplesByPaneId selector.
 */
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectEvaluationExamplesByPaneId } from "@financial-advisory/data-access/financial-advisory-api-service";
import { GroupNode as SharedGroupNode } from "@unlikelyai-magic/shared/components";
import { PaneType } from "@unlikelyai-magic/shared/data-access/api";

interface GroupNodeWithReduxProps {
  id: string;
  data: {
    productTreeId: string;
    type: PaneType;
    paneId: string;
    blurbInformation: string;
    hasTree: boolean;
    applicability?: boolean;
    applicabilityExplanation?: string;
  };
}

export const GroupNode = ({ id, data }: GroupNodeWithReduxProps) => {
  // Get evaluation examples from Redux using the pane ID
  const evaluationExamples = useSelector(
    selectEvaluationExamplesByPaneId(data.paneId)
  );

  // Inject the Redux values into the data
  // Use useMemo to avoid creating new object on every render unless values change
  const enrichedData = useMemo(
    () => ({
      ...data,
      evaluationExamples,
    }),
    [data, evaluationExamples]
  );

  return <SharedGroupNode id={id} data={enrichedData} />;
};
